

export const NoCorrectIcon = () => {

    return (
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8 0.505371C3.5848 0.505371 0 4.09017 0 8.50537C0 12.9206 3.5848 16.5054 8 16.5054C12.4152 16.5054 16 12.9206 16 8.50537C16 4.09017 12.4152 0.505371 8 0.505371ZM6.868 8.50537L4.6056 6.24217C4.2936 5.93017 4.2936 5.42297 4.6056 5.11097C4.9176 4.79897 5.4248 4.79897 5.7368 5.11097L8 7.37417L10.2624 5.11097C10.5744 4.79897 11.0816 4.79897 11.3936 5.11097C11.7064 5.42297 11.7064 5.93017 11.3936 6.24217L9.1312 8.50537L11.3936 10.7678C11.7064 11.0798 11.7064 11.587 11.3936 11.899C11.0816 12.2118 10.5744 12.2118 10.2624 11.899L8 9.63657L5.7368 11.899C5.4248 12.2118 4.9176 12.2118 4.6056 11.899C4.2936 11.587 4.2936 11.0798 4.6056 10.7678L6.868 8.50537Z" fill="#DB1212" />
        </svg>


    );
};
